<template>
  <ProgressCell
    class="ProductProgress"
    icon="laptop"
    :isFlexible="true"
    :isLoading="isProcessing"
    :label="label"
    :theme="theme"
    @click="pickProducts" />
</template>

<script>
import { actions, getters } from '@utils'
import { prop, propEq } from 'rambda'
import ProgressCell from './ProgressCell'
import sift from 'sift'

export default {
  components: { ProgressCell },
  props: {
    article: { type: Object, required: true },
    articleLaptops: { type: Array, required: true },
  },
  data() {
    return {
      isCreatingBlueprint: false,
    }
  },
  computed: {
    alternativesCount() {
      return this
        .articleLaptops
        .filter(prop('alternativeToLaptopId'))
        .length
    },
    mainCount() {
      return this
        .articleLaptops
        .filter(propEq('alternativeToLaptopId', null))
        .length
    },
    label() {
      const { alternativesCount, mainCount } = this

      if (!(alternativesCount + mainCount)) return ''

      return `${this.mainCount} (${this.alternativesCount})`
    },
    jobs() {
      return this
        .query('articleBlueprint', {
          articleId: this.article.id,
          'scheme.doPickProducts': true,
        })
    },
    isProcessing() {
      return this.isCreatingBlueprint ||
        this.hasJobs({ isProcessing: true })
    },
    theme() {
      if (this.isProcessing) return 'info'

      const hasPending = this.hasJobs({
        startedAt: null,
      })

      if (hasPending) return 'info'

      const hasFailed = this.hasJobs({
        failedAt: { $ne: null },
      })

      if (hasFailed) return 'danger'

      return this.mainCount
        ? 'success'
        : 'neutral'
    },
    ...getters(),
  },
  methods: {
    hasJobs(query) {
      return this.jobs.some(sift(query))
    },
    pickProducts() {
      return this.$wrap(
        () => this.CREATE_ARTICLE_BLUEPRINT({
          articleId: this.article.id,
          siteId: this.article.siteId,
          scheme: { doPickProducts: true },
        }),
        'isCreatingBlueprint',
      )
    },
    ...actions('CREATE_ARTICLE_BLUEPRINT'),
  },
}
</script>

<style lang="scss">
.ProductProgress {
}
</style>
